import { Alias } from '../../alias/models/alias';

export class AlertRule {

    // eslint-disable-next-line max-params
    constructor(
        readonly id: number,
        readonly color: string,
        readonly rule_description: string,
        readonly lower_higher: LowerHigher,
        readonly measured_resource: MeasuredResource,
        readonly message_content: MessageContent,
        readonly percent_limit: number,
        readonly priority: Priority,
        readonly rule_name: string,
        readonly time_to_alert: number,
        readonly time_unit: TimeUnit,
        readonly rule_alias: RuleAlias[]
    ) {}

}

export enum LowerHigher {
    Lower = '<',
    Higher = '>'
}

export enum MeasuredResource {
    CPU = 'CPU',
    RAM = 'RAM',
    Disk = 'Disk',
    Java = 'Java'
}

export enum MessageContent {
    LowerEN = 'lowerEN',
    LowerES = 'lowerES',
    LowerPT = 'lowerPT',
    HigherEN = 'higherEN',
    HigherES = 'higherES',
    HigherPT = 'higherPT'
}

export enum Priority {
    Critical = 'critical',
    Medium = 'medium',
    Low = 'low'
}

export enum TimeUnit {
    Minutes = 'm'

}

export class RuleAlias {
    constructor(
        readonly alias: Alias,
        readonly via: Via
    ) {}
}

export enum Via {
    Email = 'Mail',
    SMS = 'SMS'
}